import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { normalizeMediaUrl, DEFAULT_POSTER_SVG } from '../utils/media';

const PlayIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5v14l11-7z" /></svg>
);

export default function VideoCard({ item, type }) {
  const linkPath = type === 'series' ? `/series/${item.id}` : `/video/${item.id}`;
  const initialThumb = normalizeMediaUrl(item?.thumbnail) || DEFAULT_POSTER_SVG;
  const [imgSrc, setImgSrc] = useState(initialThumb);

  useEffect(() => {
    setImgSrc(normalizeMediaUrl(item?.thumbnail) || DEFAULT_POSTER_SVG);
  }, [item?.thumbnail]);

  const handleError = () => {
    setImgSrc(DEFAULT_POSTER_SVG);
  };

  return (
    <div className="video-card">
      <Link to={linkPath} className="video-card-link">
        <div className="video-card-thumbnail">
          <img
            src={imgSrc}
            alt={item?.title || 'Video'}
            loading="lazy"
            decoding="async"
            referrerPolicy="no-referrer"
            onError={handleError}
          />
          <div className="video-card-badge">{type === 'series' ? 'Series' : 'HD'}</div>
          {item?.rating && <span className="video-card-rating">{item.rating}</span>}
          <div className="video-card-overlay">
            <span className="video-card-play"><PlayIcon /></span>
          </div>
        </div>
        <div className="video-card-info">
          <p className="video-card-title">{item?.title}</p>
          <div className="video-card-meta">
            {item?.genre && <span className="video-card-genre">{item.genre}</span>}
            {type === 'series' && item?.seasons && (
              <span>{item.seasons} Season{item.seasons > 1 ? 's' : ''}</span>
            )}
          </div>
          <span className="video-card-price">TSh {Number(item?.price || 0).toFixed(2)}</span>
        </div>
      </Link>
    </div>
  );
}
